import * as React from 'react';
import Image from 'components/Image';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';

import close from 'images/flat-close.svg';

const VideoModal = ({title, src, open, onClose}) => {
	const videoWrapper = {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		boxShadow: 0,
		zIndex: 1000,
		width: '80%',
		height: 'auto',
	};

	const closeStyle = {
		cursor: "pointer", 
		position: "absolute", 
		top: "-2rem", 
		right: "-2rem", 
		zIndex: 9999,
		padding: ".5rem",
		background: "rgba(0, 0, 0, 0.5)",
		borderRadius: "50%",
		border: "1px solid #fff",
	}
	
	return (
		<Modal
			open={open}
			onClose={onClose}
			className="video-modal"
		>
			<Box sx={videoWrapper}>
				{/*Add close.svg to video modal*/}
				<Image style={closeStyle} onClick={onClose} width={"60"} height={"60"} src={close} alt="Close video modal." />
				<Box sx={{ position: 'relative', paddingTop: '50%', height: 0 }}>
					<iframe
						title={title}
						src={src}
						frameBorder="0"
						allow="encrypted-media; autoplay; controls"
						height={"100%"}
						width={"100%"}
						style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
					/>
				</Box>
			</Box>
		</Modal>
	)
}

export default VideoModal;